import React from "react";
import styles from "./login.module.css";
import logo from '../../../Assets/KS_Logo_New.png';
import { Navigate } from "react-router-dom"
import { AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from '@azure/msal-react';

async function signInClickHandler(instance) {
  try {
    await instance.loginPopup();
  } catch (error) {
    if (error.errorCode === "user_cancelled") {
      // User closed popup without signing in
      return;
    } else {
      // Handle all other errors
      console.error(error.message || error);
    }
  }

}

function SignInButton() {
  // useMsal hook will return the PublicClientApplication instance we provided to MsalProvider
  const { instance } = useMsal();

  return (
    <button
      type="button"
      className={styles.button}
      style={{ background: '#2F2F6F', color: '#fff' }}
      onClick={() => signInClickHandler(instance)}
    >
      Login with Microsoft
    </button>
  );
}

const Login = () => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  return (
    <div className="login-page">
      <div className={styles.container}>
        <div className="login-card">
          <div className={styles.logoContainer}>
            <img src={logo} alt="Brand Logo" className={styles.logo} />
          </div>
          <div style={{ textAlign: 'center', marginTop: '1rem' }}>
            <AuthenticatedTemplate>
              {activeAccount ? (
                <Navigate to="/dashboard" replace />
              ) : null}
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
              <SignInButton />
            </UnauthenticatedTemplate>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
